/**
 * Loader for Spectrum colour picker
 * 
 * Run with `new ColourPicker()` or `new ColourPicker(args)`
 * 
 * args:
 * - el: the element, defaults to .js-colour-picker
 * - parent: set this if colour picker is inside a modal
 * 
 * The <input> can be either `type="color"` or `type="text"`. Note that the former doesn't like 3-digit hexes.
 */

import buildIcon from "Scripts/common/build-icon";
import Spectrum from "Vendor/spectrum-colorpicker";

export default class ColourPicker {
	constructor(args) {
		this.timer;
		this.localStorageKey = "spectrum.gayl"

		$(args?.el || '.js-colour-picker').each((i,picker) => {
			const element       = $(picker);
			const initialColour = element.data('initialColour');

			if(initialColour.length) {	
				element.val(initialColour);
			}

			element.spectrum({
				color: initialColour,
				preferredFormat: "hex",

				// Show the <input> so can type in colour
				showInput: true,

				// Show the palettes
				showPalette: true,
				showSelectionPalette: true,

				// Clear the preset palete, otherwise a load of random colours are shown
				palette: [],
				
				// This means any saved colours will be added to the palette, handy if multiple pickers on one page
				localStorageKey: this.localStorageKey,

				// Override the button text
				chooseText: 'Save',
				appendTo: args?.parent,

				// Events
				show: colour => this.onShow(colour, element),
				move: colour => this.onMove(colour, element),
			});
		});
	}

	onShow(colour, element) {
		this.initialColours = localStorage?.getItem(this.localStorageKey)?.split(";") || [];
		this.onMove(colour, element);

		// Hack to show FontAwesome icon
		$(".sp-choose").html(buildIcon('fa-check') + ' Save');
	}

	onMove(colour, element) {
		const hue = colour.toHsl().h;
		const hueColour = tinycolor({ h: hue, s: 100, l: 0.5 });

		// In our CSS, we've made the dragger have a transparent background colour, this updates so it acts like magnifying glass
		$(".sp-dragger").css("background", colour.toHexString());

		// Same for the slider, but not if hue == 0 (i.e. true greyscale), otherwise it goes red whatever the colour!
		if(hue > 0) {
			$(".sp-slider").css("background", hueColour.toHexString());
		}

		clearTimeout(this.timer);

		// Wait for 100ms of non-moving and then set the colour
		// We do this rather than use the dragstop event as the below also works with selecting a colour from the saved palette
		this.timer = setTimeout(async () => {
			this.setLocalStorage(colour, element);
			element.spectrum('set', colour.toHexString()).trigger('change');
		}, 100);
	}

	/**
	 * Spectrum saves palette colours to LocalStorage, so that it shows a list of relevant colours
	 * Although Spectrum deals with LocalStorage itself, because of our onMove->trigger above,
	 * moving the dragger/slider will cause lots of colours to be saved to the LocalStorage and mess it up
	 * This functions ensures only one colour is added
	 */
	setLocalStorage(colour, element) {
		console.log("ColourPicker.onChange", colour, colour.toRgbString());

		if(!window.localStorage) return;

		const newColour = colour.toRgbString();
		const latestColours = localStorage.getItem(this.localStorageKey).split(";") || [];
		const finalColours = [...this.initialColours];

		if(!finalColours.includes(newColour)) {
			finalColours.push(newColour);
			localStorage.setItem(this.localStorageKey, finalColours.join(";"));
		}
	}
}